import { render, staticRenderFns } from "./MarketplaceInvoiceLayout.vue?vue&type=template&id=7c5cdffb&scoped=true&"
import script from "./MarketplaceInvoiceLayout.vue?vue&type=script&lang=js&"
export * from "./MarketplaceInvoiceLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5cdffb",
  null
  
)

export default component.exports